<div class="layout-main">
  <div class="container-fluid">
    <div class="page-header pb-2 mb-3 border-bottom">
      <h3><b>Encryption key availability</b></h3>
      <span *ngIf="availableKeys" class="week-chip">
        <i aria-hidden="true" class="fa fa-calendar"></i>
        Week {{ weekDisplayed }}
      </span>
    </div>
    <p-table [loading]="loading" [rowHover]="true" [tableStyle]="{'table-layout':'auto'}" [value]="keysInformation"
             id="qed-multicast-table">
      <ng-template pTemplate="loadingicon">
        <p-progressSpinner [style]="{width: '48px', height: '48px'}" animationDuration="1.2s"
                           strokeWidth="4"></p-progressSpinner>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th [attr.rowspan]="pops.length ? 2 : 1">Channels</th>
          <th *ngIf="pops.length" [attr.colspan]="pops.length" class="pop-group-header">POPs</th>
        </tr>
        <tr *ngIf="pops.length">
          <th *ngFor="let pop of pops" class="pop-header">
            <span [pTooltip]="technicalPopService.getCageTooltip(pop | uppercase)">{{ pop | uppercase }}</span>
          </th>
        </tr>
      </ng-template>
      <ng-template let-keyInformation pTemplate="body">
        <tr>
          <td class="record-cell">{{ keyInformation['channel'] }}</td>
          <td *ngFor="let pop of pops" class="key-cell">
            <button (click)="displayItem($event, keyInformation, pop, op1)" *ngIf="keyInformation['pops'][pop]; else noKey"
                    class="key-count" type="button">{{ keyInformation['pops'][pop]['prod'] || 0 }}</button>
            <ng-template #noKey><span class="key-empty">-</span></ng-template>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="pops.length + 1">
            <div *ngIf="loadError" class="empty-state">
              <i aria-hidden="true" class="fa fa-exclamation-triangle"></i>
              <div class="empty-state-title">The encryption keys could not be loaded</div>
              <div class="empty-state-subtitle">Please try again later.</div>
            </div>
            <div *ngIf="!loadError" class="empty-state">
              <i aria-hidden="true" class="fa fa-search"></i>
              <div class="empty-state-title">Keys not available</div>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-overlayPanel #op1 [dismissable]="true" appendTo="body" styleClass="key-info-panel">
      <div class="key-info-header">
        <div class="key-info-channel">{{ channelSelected }}</div>
        <div class="key-info-pop">POP · {{ popSelected | uppercase }}</div>
      </div>
      <div class="key-info-stats">
        <div class="key-info-stat">
          <div class="key-info-stat-label">PROD</div>
          <div class="key-info-stat-value">{{ numberOfProdKeys }}</div>
        </div>
        <div class="key-info-stat">
          <div class="key-info-stat-label">UAT</div>
          <div class="key-info-stat-value">{{ numberOfUatKeys }}</div>
        </div>
      </div>
    </p-overlayPanel>
  </div>
</div>
